import { IReleaseNote } from "../types"

export const RELEASE_2_0_0: IReleaseNote = {
    status: "PAST",
    title: "v2.0.0",
    date: "30th September 2025",
    releaseType: "Major",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "We are excited to announce ENA Connect Direct 2.0.0 was released on the 30th September 2025. This is a major release, and it contains new features to make the site better, faster and more accurate. These notes outline the key changes",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            subtitle: "Feature Summary",
            bullets: [
                "Commissioning Auto-Approvals: Commission applications will be auto-approved provided they meet the validation checks imposed on the commissioning application",
                "Solo Installer Company: Solo installers will be moved into an installer company group to provide them with enhanced self-service functionality through the existing platform. This transition will also allow the company name and phone number to be automatically pre-filled in the application form",
            ],
        },
        {
            heading: "The following changes have been added:",
        },
        {
            subtitle: "Commissioning Auto-Approvals: ",
            bullets: [
                "A commissioning application will be automatically approved if its total installed capacity is below the DNO threshold",
                "Automatically approved applications will be marked with the status 'Commissioning Accepted'",
                "Applications that don’t meet the auto-approval criteria will go through the existing manual approval process",
                "Where the Export MPAN is provided by the DNO rather than the Energy Retailer, the export MPAN will be provided after the commissioning auto-approval. The new Status 'Ex MPAN Provided' will be seen in the 'My Applications' page",
            ],
        },
        {
            subtitle: "Solo Installer Company:",
            bullets: [
                "New installers will be automatically routed through the installer company onboarding process, while existing solo installers will be migrated and assigned the INSTALLER-ADMIN role",
                "The installer company admin page will allow admins to edit the company name, address (line 1 and postcode), and phone number. These changes will not be applied retrospectively to existing connection applications",
                "Installers will now have the option to enter an individual phone number",
                "The company name and phone number are to be pre-populated in the application form",
                "Multi-Factor Authentication (MFA) will be required for all users, including those in Installer Companies",
            ],
        },
        {
            heading: "For installers using our APIs",
            subtitle: "Feature Summary",
            bullets: [
                "Commissioning Auto-Approvals: Commission applications will be auto-approved provided they meet the validation checks imposed on the commissioning application",
                "Additional info: Users can now include optional fields in the payload — 'Address Line 2' and 'Additional Number'.",
            ],
        },
        {
            heading: "The following changes have been added:",
        },
        {
            subtitle: "Commissioning Auto-Approvals:",
            bullets: [
                "A commissioning application will be automatically approved if its total installed capacity is below the DNO threshold",
                "Automatically approved applications will be marked with the status 'Commissioning Accepted'",
                "Applications that don’t meet the auto-approval criteria will go through the existing manual approval process",
                "Where the Export MPAN is provided by the DNO rather than the Energy Retailer, the export MPAN will be provided after the commissioning auto-approval. The new Status 'Ex MPAN Provided' will be seen in the 'My Applications' page",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            subtitle: "Feature Summary",
            bullets: [
                "Commissioning Auto-Approvals: Commission applications will be auto-approved provided they meet the validation checks imposed on the commissioning application",
                "Provide Export MPAN: Details can be found within the Migration Guide",
            ],
        },
        {
            heading: "The following changes have been added:",
            subtitle: "Commissioning Auto-Approvals:",
            bullets: [
                "DNOs will set a fixed commissioning approval threshold (in kW per phase). This threshold applies to all applications submitted to that DNO",
                "Commissioning applications that are auto-approved will be marked with the status 'Commissioning Accepted",
                "When an application is auto-approved, the standard DNO commissioning approval email will be sent",
                "Applications that do not meet the auto-approval criteria will require manual approval through the existing process",
                "After auto-approval, DNOs can submit the export MPAN via an API or a bespoke webform, resulting in the application status becoming EX MPAN Provided",
            ],
        },
        {
            heading: "For DNOs using our APIs",
            subtitle: "Feature Summary",
            bullets: [
                "Commissioning Auto-Approvals: Commission applications will be auto-approved provided they meet the validation checks imposed on the commissioning application",
            ],
        },
        {
            heading: "The following changes have been added:",
            subtitle: "Commissioning Auto-Approvals:",
            bullets: [
                "DNOs will set a fixed commissioning approval threshold (in kW per phase). This threshold applies to all applications submitted to that DNO",
                "Commissioning applications that are auto-approved will be marked with the status 'Commissioning Approved",
                "When an application is auto-approved, the standard DNO commissioning approval email will be sent",
                "Applications that do not meet the auto-approval criteria will require manual approval through the existing process",
                "After auto-approval, DNOs can submit the export MPAN via an API or a bespoke webform, resulting in the application status becoming EX MPAN Provided",
            ],
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "No changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "No changes to your functionality ",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "No changes to your functionality",
        },
    ],
}
